import { useSelector } from "react-redux";
import axios from "axios";
import uuid from "react-uuid";

const useUploadFiles = () => {
  const user = useSelector((state) => state?.user?.data[0]);

  // 파일을 서버에 업로드
  const uploadFiles = async (files) => {
    if (!user || !Array.isArray(files) || files.length === 0) return [];

    const formData = new FormData();
    files.forEach((item) => {
      const fileName = item.name || `${uuid()}.png`;
      formData.append("files", item, fileName);
    });

    formData.append("ids", "N");
    formData.append("mberNo", user?.mberNo);

    try {
      const res = await axios.post("/api/uploadFiles", formData);
      return res.data?.responseData || [];
    } catch (error) {
      console.error("파일 업로드 실패", error);
      return [];
    }
  };

  // HTML에서 base64 이미지 추출
  const extractImages = (content) => {
    const imgRegex = /<img.*?src=['"](data:image\/\w+;base64,.*?)['"].*?>/g;
    const matches = content.match(imgRegex);
    const blobs = [];

    if (matches) {
      matches.forEach((match) => {
        const base64Match = match.match(/src=['"](data:image\/\w+;base64,.*?)['"]/);
        if (base64Match && base64Match[1]) {
          const blob = dataURItoBlob(base64Match[1]);
          blobs.push(blob);
        }
      });
    }

    return blobs;
  };

  // base64 - Blob 변환
  const dataURItoBlob = (dataURI) => {
    const byteString = atob(dataURI.split(",")[1]);
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    const extension = mimeString.split("/")[1];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeString });
    blob.name = `${uuid()}.${extension}`;
    return blob;
  };

  // base64 이미지를 업로드된 URL로 교체
  const replaceSources = (content, uploadedUrls) => {
    let updated = content;
    const dataUriRegex = /src=['"]data:image\/[^;'"]+;base64,[^'"]+['"]/g;
    const matches = content.match(dataUriRegex);

    uploadedUrls.forEach((url, idx) => {
      if (matches && matches[idx]) {
        updated = updated.replace(matches[idx], `src="${imgHandler(url)}"`);
      }
    });

    return updated;
  };

  //  HTML 내 base64 이미지 업로드 및 치환
  const uploadEmbedded = async (htmlContent) => {
    const blobs = extractImages(htmlContent);
    const uploaded = await uploadFiles(blobs);
    return replaceSources(
      htmlContent,
      uploaded.map((f) => f.fileName),
    );
  };

  // Base64 인코딩 문자열로 반환
  const readFileAsDataURL = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => resolve(event.target.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  return {
    uploadFiles,
    uploadEmbedded,
    extractImages,
    replaceSources,
    dataURItoBlob,
    readFileAsDataURL,
  };
};

export default useUploadFiles;
